import { render, staticRenderFns } from "./SubtaskEditor.vue?vue&type=template&id=ad99b54a"
import script from "./SubtaskEditor.vue?vue&type=script&lang=js"
export * from "./SubtaskEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports